import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaUpdateCedenteResponse } from '../interface/entuba/cedente/IEntubaUpdateCedenteResponse';
import { IEntubaUpdateCedenteDetailResponse } from '../interface/entuba/cedente/IEntubaUpdateCedenteDetailResponse';
import { IEntubaUpdateCedenteRequest } from '../interface/entuba/cedente/IEntubaUpdateCedenteRequest';

enum EntubaCedenteServiceEnum {
  base = "/",
  start = "/",
}

export default class EntubaUpdateCedenteService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba/cedente");
  }

  public getAll = async (): Promise<IEntubaUpdateCedenteResponse[]> => await this.GET(EntubaCedenteServiceEnum.base);
  public getDetail = async (id: number): Promise<IEntubaUpdateCedenteDetailResponse> => await this.GET(`${EntubaCedenteServiceEnum.base}${id}`);
  public start = async (data: IEntubaUpdateCedenteRequest) => await this.PUT(EntubaCedenteServiceEnum.start, data);
}



// WEBPACK FOOTER //
// ./src/services/api/EntubaUpdateCedente.service.ts